import styled from "styled-components";
export const ContainerFooter = styled.div<{ isAbsolute: boolean }>`
  display: flex;
  justify-content: end;
  padding: 5px 10px;
  background: #2c2c2c;
  height: 27px;
  width: 100%;
  position: ${(props) => (props.isAbsolute ? "absolute" : "")};
  bottom: 0;
  left: 0;
  font-size: 14px;
  color: #fff;
  gap: 5px;
  a {
    text-decoration: none;
    color: #fff;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 10px;
    gap: 5px;
    font-size: 12px;
  }
`;
